module.exports = __webpack_public_path__ + "img/Rich & Creamy.81ec02a3.jpg";